module.exports = __webpack_public_path__ + "img/icon-notif-open.4897c431.svg";